import type { Testimonial } from '../testimonials'

/**
 * Semih Özçelik's words — the second tab of the quote card that closes
 * digitopia.co/customers/penta-teknoloji/, sent on 2026-09-04 with his portrait
 * and the instruction that the two options read as one card ("iki seçenek
 * birbiri ile uyumlu ve bütünlüklü olsun").
 *
 * It is a second file rather than an edit of `penta-teknoloji.ts`, because a
 * card holds one speaker and `testimonialsForStory()` gathers every quote that
 * names the story into the tab strip — the same shape Akkök Holding's two
 * principals take. His paragraph is set as one paragraph of the same length as
 * Ms Budak's, saying the alignment side of the same engagement.
 */
export const added: Testimonial = {
  company: 'Penta Teknoloji',
  logo: { name: 'Penta Teknoloji', src: '/logo/pentacard.png' },
  portrait: {
    src: '/photo/penta-semih-ozcelik.png',
    alt: 'Semih Özçelik',
  },
  quote: [
    'Thanks to our collaboration with Digitopia, coordination between our Digital '
    + 'Transformation and Operations teams and our business units has strengthened. The '
    + 'priorities defined on the platform were linked directly to our business objectives and '
    + 'tracked consistently, making our digital transformation journey more structured.',
  ],
  attribution: 'Semih Özçelik, Process Management and Automation Manager',
  story: 'penta-teknoloji',
  // Asked for on 2026-09-05: his words are the Penta page's second option and
  // are not wanted on the Hall of Fame wall. Ms Budak's card stays there and
  // still speaks for Penta; this file stays a testimonial so the story page's
  // tab strip keeps both tabs.
  hallOfFame: false,
}

/**
 * Second of Penta's two tabs, which is what the request asked for ("2. seçenek")
 * — so both Penta files carry an explicit `order` rather than leaving the two to
 * tie on company and fall back to whatever order the glob returns.
 */
export const order = 21
